import { getFrontendConfigLoader } from '@doxyme/config';

export const getGraphqlApolloRouterBaseUrl = (
  config = getFrontendConfigLoader(),
): string => {
  const apolloEndpoint = config.getOptional('APOLLO_ROUTER_GRAPHQL_URL');

  if (apolloEndpoint === undefined) {
    throw new Error('Apollo endpoint url is undefined');
  }

  return apolloEndpoint as string;
};
